export default __webpack_public_path__ + "static/media/user_deactivated.4ece3073.svg";